/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ConfirmedbasketsIdNopaymentmethodPut200Response from '../model/ConfirmedbasketsIdNopaymentmethodPut200Response';
import ConfirmedbasketsIdNopaymentmethodPutRequest from '../model/ConfirmedbasketsIdNopaymentmethodPutRequest';

/**
* ConfirmedBaskets service.
* @module api/ConfirmedBasketsApi
* @version 1.0.0
*/
export default class ConfirmedBasketsApi {

    /**
    * Constructs a new ConfirmedBasketsApi. 
    * @alias module:api/ConfirmedBasketsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Get an existing confirmed basket
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    confirmedbasketsIdGetWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling confirmedbasketsIdGet");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/confirmedbaskets/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get an existing confirmed basket
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    confirmedbasketsIdGet(id) {
      return this.confirmedbasketsIdGetWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Create a hosted payment method
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
    confirmedbasketsIdHostedPaymentPostWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling confirmedbasketsIdHostedPaymentPost");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/confirmedbaskets/{id}/hostedPayment', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Create a hosted payment method
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
    confirmedbasketsIdHostedPaymentPost(id) {
      return this.confirmedbasketsIdHostedPaymentPostWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Create a no-payment payment method for a confirmed basket
     * Proxies `POST /users/${userId}/confirmedbaskets/${basketId}/paymentmethods/nopayment` to SSB
     * @param {Number} id Confirmed basket ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ConfirmedbasketsIdNopaymentmethodPutRequest} and HTTP response
     */
    confirmedbasketsIdNopaymentmethodPostWithHttpInfo(id) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling confirmedbasketsIdNopaymentmethodPost");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ConfirmedbasketsIdNopaymentmethodPutRequest;
      return this.apiClient.callApi(
        '/confirmedbaskets/{id}/nopaymentmethod', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Create a no-payment payment method for a confirmed basket
     * Proxies `POST /users/${userId}/confirmedbaskets/${basketId}/paymentmethods/nopayment` to SSB
     * @param {Number} id Confirmed basket ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ConfirmedbasketsIdNopaymentmethodPutRequest}
     */
    confirmedbasketsIdNopaymentmethodPost(id) {
      return this.confirmedbasketsIdNopaymentmethodPostWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Submit confirmed basket with no payment
     * Proxies `PUT /users/{userId}/confirmedbaskets/{basketId}/paymentmethods/nopayment/{paymentmethodId}` to SSB.
     * @param {Number} id Confirmed basket ID
     * @param {module:model/ConfirmedbasketsIdNopaymentmethodPutRequest} confirmedbasketsIdNopaymentmethodPutRequest Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ConfirmedbasketsIdNopaymentmethodPut200Response} and HTTP response
     */
    confirmedbasketsIdNopaymentmethodPutWithHttpInfo(id, confirmedbasketsIdNopaymentmethodPutRequest) {
      let postBody = confirmedbasketsIdNopaymentmethodPutRequest;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling confirmedbasketsIdNopaymentmethodPut");
      }
      // verify the required parameter 'confirmedbasketsIdNopaymentmethodPutRequest' is set
      if (confirmedbasketsIdNopaymentmethodPutRequest === undefined || confirmedbasketsIdNopaymentmethodPutRequest === null) {
        throw new Error("Missing the required parameter 'confirmedbasketsIdNopaymentmethodPutRequest' when calling confirmedbasketsIdNopaymentmethodPut");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ConfirmedbasketsIdNopaymentmethodPut200Response;
      return this.apiClient.callApi(
        '/confirmedbaskets/{id}/nopaymentmethod', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Submit confirmed basket with no payment
     * Proxies `PUT /users/{userId}/confirmedbaskets/{basketId}/paymentmethods/nopayment/{paymentmethodId}` to SSB.
     * @param {Number} id Confirmed basket ID
     * @param {module:model/ConfirmedbasketsIdNopaymentmethodPutRequest} confirmedbasketsIdNopaymentmethodPutRequest Payment details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ConfirmedbasketsIdNopaymentmethodPut200Response}
     */
    confirmedbasketsIdNopaymentmethodPut(id, confirmedbasketsIdNopaymentmethodPutRequest) {
      return this.confirmedbasketsIdNopaymentmethodPutWithHttpInfo(id, confirmedbasketsIdNopaymentmethodPutRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
